"use client";

import { SwitchRoiForm as SharedSwitchRoiForm } from "@/components/compare/SwitchRoiForm.client";

export function SwitchRoiForm() {
  return (
    <SharedSwitchRoiForm
      competitorValue="appspace"
      competitorLabel="Appspace"
      formName="switch_roi_appspace"
    />
  );
}
